@if (!userService.isLoggedin) {
  <div class="single_page_wrapper d-flex flex-column">
    <div class="logo_header text-center p-2">
      <a class="brand fc-quest-brand" href="/" title="Family Central">
        <img
          src="./assets/images/logos/FamilyCentral-logo-StackHorz.svg"
          alt="Family Central logo"
        />
      </a>
    </div>
    <div
      class="single_page_body d-flex justify-content-center align-items-center flex-grow-1"
    >
      <div class="single_page_content">
        <p class="text-center mb-3">
          Family Central is a web and mobile app to organize a family's
          day-to-day life. Family Central, your go-to resource, gives you and
          your family peace of mind knowing that all the details and documents
          are within reach to help you today and in the future.
        </p>
        <form id="msform" method="post" name="registration">
          <div class="card_wrapper">
            <div class="card_container">
              <div class="card_header text-center">
                <p class="fs-5 mb-0">Welcome to the</p>
                <h2 class="h2">
                  {{ familyInviationService?.invitationDetails?.familyName }}
                  Family
                </h2>
              </div>
              <div
                class="form-group submit_btn text-center d-flex flex-column gap-3"
              >
                <a class="primary_btn w-100" routerLink="/questionnaires"
                  >Join your family</a
                >
                <button
                  type="button"
                  class="border_btn w-100"
                  (click)="showFamily()"
                >
                  View Family Members
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
}

<!-- View Family Members Modal -->
<ng-template #familyMembers id="family-profile">
  <div class="fc_modal_body">
    <button
      type="button"
      class="btn-close"
      (click)="modalService.dismissAll()"
    ></button>
    <h3 class="h3">View Family Members</h3>

    <div class="family_list d-grid gap-2 mt-3">
      @for (
        member of familyInviationService?.invitationDetails?.familyMembers;
        track member
      ) {
        <div class="single_profile card_wrapper">
          <div class="profile_content card_container text-center">
            <div class="mb-3">
              <img
                alt="profile"
                src="/assets/images/MyFamily/empty-profile.svg"
              />
            </div>
            <div class="family_name">
              <h4 class="mb-0 fs-5">{{ member.firstName }}</h4>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
